import { getEnvironment } from 'toolkit/environment/environment/environment';

/**
 * Helper class for generating Avon URLs.
 */
export class AvonUrlHelper {
  /**
   * The base URL for the EMR system.
   */
  static emrBaseUrl: string;

  /**
   * Sets the base URL for the EMR system based on the current environment.
   */
  static setBaseUrl() {
    const env = getEnvironment();
    this.emrBaseUrl = env.emrBaseUrl;
  }

  /**
   * Returns the URL for the Avon calendar.
   * @returns The URL for the Avon calendar.
   */
  static getAvonCalendarUrl() {
    if (!this.emrBaseUrl) this.setBaseUrl();

    return `${this.emrBaseUrl}/calendar`;
  }

  /**
   * Returns the URL for the member profile page.
   * @param avonMemberId - The ID of the Avon member.
   * @returns The URL for the member profile page.
   */
  static getMemberProfileUrl(avonMemberId: string) {
    if (!this.emrBaseUrl) this.setBaseUrl();
    const cleanAvonMemberId = avonMemberId.replace(/^user_/, '');
    return `${this.emrBaseUrl}/patient/overview?id=${cleanAvonMemberId}`;
  }
}
